import React, { useEffect } from 'react'
import {
  ReferenceInput,
  AutocompleteInput,
  useLocaleState,
  AutocompleteInputProps,
  required,
} from 'react-admin'

import { COMMON_FIELDS } from '../../providers/localization/constant'
import { useFormContext, useWatch } from 'react-hook-form'

const defaultProps = {
  label: `${COMMON_FIELDS}.public_news.label`,
  source: 'target_value',
}

export const PublicNewsSelectInput: React.FC<AutocompleteInputProps> = ({
  label,
  source,
  ...props
}) => {
  const depField = 'target_link'
  const expectedValue = 'news'

  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(source)
    }
  }, [fieldCond, source, unregister])

  const [locale] = useLocaleState()

  if (!depField) return null
  const validator = {
    validate: [required()],
  }
  const optionRenderer = (choice): string => {
    return choice[`title_${locale}`] !== undefined
      ? `${choice[`title_${locale}`] || choice['title_th']}`
      : `${COMMON_FIELDS}.public_news.clear`
  }

  return fieldCond === expectedValue ? (
    <ReferenceInput
      source={source}
      reference='news'
      sort={{
        field: 'create_at',
        order: 'DESC',
      }}
      filter={{
        name: null,
        is_published: true,
        type: 'c',
      }}
      fullWidth
    >
      <AutocompleteInput
        margin='none'
        label={label}
        size='small'
        optionValue='id'
        optionText={optionRenderer}
        {...(fieldCond === expectedValue ? validator : '')}
        {...props}
      />
    </ReferenceInput>
  ) : null
}

PublicNewsSelectInput.defaultProps = defaultProps
